// extracted by mini-css-extract-plugin
export default {"label":"styles-module__label__src-labstep-web-core-Label-Remove-_sbmtG","clickable":"styles-module__clickable__src-labstep-web-core-Label-Remove-_j_9HC"};